// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VQr5fr2MrQ1WskOhCOxG{flex-direction:column;gap:4px;display:flex}.VQr5fr2MrQ1WskOhCOxG .qyT6S6_n7_s33_inHQ8N{letter-spacing:-.07px;color:var(--content-primary-tertiary-inverted);line-height:15px}.TWkYCZd6d4fcwdz6ecFP{color:var(--content-primary-primary-inverted)}.TWkYCZd6d4fcwdz6ecFP a{color:var(--light-blue-50);text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `VQr5fr2MrQ1WskOhCOxG`,
	"desc": `qyT6S6_n7_s33_inHQ8N`,
	"label": `TWkYCZd6d4fcwdz6ecFP`
};
export default ___CSS_LOADER_EXPORT___;
